import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import type { Page } from '@swf/generated/cms/types/Page';

import CMSReferences from '../CMSReference/CMSReferences';

import PageBody from './PageBody/PageBody';

const selector = (rootState: RootState) => rootState.loading.effects.widgets.fetchData;

const CMSPage: React.FC<Page> = ({ content, template, theme }) => {
  const twoColumns = template === '2 Column';
  const darkTheme = theme === 'Dark';
  const loading = useSelector(selector);
  const [{ seo, top, side, main }] = content;

  return (
    <>
      <CMSReferences references={seo} />
      {loading ? (
        <Skeleton variant="rect" animation="wave" height={340} />
      ) : (
        <CMSReferences references={top} />
      )}
      <PageBody
        side={side}
        main={main}
        twoColumns={twoColumns}
        loading={loading}
        darkTheme={darkTheme}
      />
    </>
  );
};

export default CMSPage;
